import { AppRoute } from '../types';

export const flattenRoutes = (routes: AppRoute[]): AppRoute[] => {
  return routes.reduce<AppRoute[]>((acc, route) => {
    acc.push({ ...route, path: route.path as string }); // Ensure path is a string

    if (route.children?.length) {
      acc.push(...flattenRoutes(route.children));
    }

    return acc;
  }, []);
};
